export default __webpack_public_path__ + "static/media/enjoyRoom.2e783bd8.jpg";